// extracted by mini-css-extract-plugin
export const topnav = "menu-module--topnav--30ufM";
export const topnavItemImage = "menu-module--topnavItemImage--3cz5q";
export const topnavItem = "menu-module--topnavItem--1RXvp";
export const active = "menu-module--active--2uI5x";
export const icon = "menu-module--icon--26S03";